import { createSlice } from '@reduxjs/toolkit';
import { fetchGroupItemById } from '../actions/groupItemActions';

const initialState = {
  groupItems: { kits: [], count: 0 }, // Ensure groupItems has kits and count properties
  groupItem: null,
  loading: false,
  error: null,
  status: 'idle',
};

const groupItemSlice = createSlice({
  name: 'groupItem',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroupItemById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGroupItemById.fulfilled, (state, action) => {
        state.loading = false;
        state.groupItem = action.payload;
      })
      .addCase(fetchGroupItemById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default groupItemSlice.reducer;